export default __webpack_public_path__ + "static/media/download_2.0a413d37.svg";